import menusPcComp from './components/pcMenus/index.vue';
import mobileMenusComp from './components/mobileMenus/index.vue';
import { getUserUnReadNotifications } from "@/api/myAccount/notifications";
import { mapActions } from "vuex";
import languageComp from '@/components/SelectLang/index.vue';
import logAndFeedBackComp from "@/components/logAndFeedBackComp";
import {Local} from "@/utils/storage";
import teamListComp from "./components/teamList/index.vue";
export default ({
  name: 'SingleronNavMenus',
  components: {
    'menus-pc-comp': menusPcComp,
    'mobile-menus-comp': mobileMenusComp,
    'language-comp': languageComp,
    logAndFeedBackComp,
    teamListComp,
	},
  data() {
    return {
      acountList: [],
      unReadNotifications: 0,
      
    };
  },
  mounted(){
    
  },
  computed: {
    // 计算属性获取当前路由
    userInfo() {
      const userInfo = Local.get('user_info');
      const params = {
        name: userInfo ? userInfo.user_name : '',
        email: userInfo ? userInfo.email : '',
        avatar: userInfo ? userInfo.avatar : '',
      };
      return params;
    },
  },
  methods:{
    getRoute() {
      this.$refs.updateLogRef.closeDrawer();
    },
    goHome() {
      this.$router.push("/");
    },
    //清空缓存中的值
    ...mapActions(['user/logout']),
    logout() {
      this.$msgbox({
        closeOnClickModal: false,
        closeOnPressEscape: false,
        title: this.$t("message.user.logOutTitle"),
        message: this.$t("message.user.logOutMessage"),
        showCancelButton: true,
        confirmButtonText: this.$t("message.user.logOutConfirm"),
        cancelButtonText: this.$t("message.user.logOutCancel"),
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = this.$t("message.user.logOutExit");
            setTimeout(() => {
              done();
              setTimeout(() => {
                instance.confirmButtonLoading = false;
              }, 300);
            }, 700);
          } else {
            done();
          }
        },
      })
        .then(async() => {
          // this.$store.dispatch("user/logout"); // 清空 vuex 路由列表缓存
          // resetRouter(); // 删除/重置路由
          await this['user/logout']();
          this.$router.push({
                path: '/login',
                query: {
                  redirect: this.$route.fullPath,
                },
          });
          // location.reload();
        })
        .catch(() => {});
    },

    /**
     * 获取用户相关菜单
     * @param {*} acountList 
     */
    async getAcountList(acountList) {
      this.acountList = acountList;
      await this.loadNotifications();
    },

    /**
     * 处理菜单选择事件
     * @param {*} item 
     */
    handleSelect(item) {
      if (item.id === 'Logout') {
        this.logout();
      } else {
        this.handleRoute(item);
      }
    },

    
    /**
     * 处理路由跳转
     * @param {*} item 
     */
    handleRoute(item) {
      this.getRoute();
      this.$router.push({
        path: item.routePath,
      });
    },

    /**
     * 获取通知数
     * @returns 
     */
    async loadNotifications() {
      try {
        const serverData = await getUserUnReadNotifications();
        if (!serverData.data) {
          return;
        }
        const data = serverData.data;
        if (data > 99) {
          this.unReadNotifications = '99+';
        } else if (data > 0) {
          this.unReadNotifications = data;
        } else {
          this.unReadNotifications = 0;
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
  },
});
